import { ActionReducer } from '@ngrx/store';
import { ACTION_LOGOUT_NAME } from './auth/auth.actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearState = (reducer: ActionReducer<any>): ActionReducer<any> =>
  (state, action) => {
    if (action.type === ACTION_LOGOUT_NAME) {
      const clearedState = {};
      return reducer(clearedState, action);
    } else {
      return reducer(state, action);
    }
  };
